{
  "version": 1,
  "asset_id": "9072a52d-4b0b-4e50-9e7a-3f7df1fc3aa9",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/9072a52d-4b0b-4e50-9e7a-3f7df1fc3aa9/svc-technical-seo-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/9072a52d-4b0b-4e50-9e7a-3f7df1fc3aa9/svc-technical-seo-640.webp",
  "original_filename": "svc-technical-seo-640.webp",
  "size": 11912,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:58Z"
}
